import { PUBLIC_CONTACT_EMAIL } from "../../config/publicContact";
import JudiMark from "../ui/JudiMark";
import { NAV_LINKS } from "./navLinks";
import LegalLinks from "../misc/LegalLinks";

export default function LandingFooter() {
  return (
    <footer className="border-t border-warm-border bg-warm-bg-elevated">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <JudiMark className="w-6 h-6" />
            <span className="font-display text-lg text-warm-text-primary italic">JuDI</span>
          </div>
          <nav className="flex items-center gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-warm-text-secondary hover:text-warm-text-primary transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-warm-border flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-warm-text-tertiary">
          <span>&copy; {new Date().getFullYear()} JuDI. Your tasks, under control.</span>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href={`mailto:${PUBLIC_CONTACT_EMAIL}`}
              className="text-sm text-warm-text-secondary hover:text-warm-text-primary transition-colors"
            >
              {PUBLIC_CONTACT_EMAIL}
            </a>
            <LegalLinks />
          </div>
        </div>
      </div>
    </footer>
  );
}
